import { SharedValue } from "react-native-reanimated";

import { NumericalDayOfWeek } from "@whoosh/utilities/src/calendars";

import {
  TeeSheetAgendaHeaderDesktopNew,
  TeeSheetAgendaHeaderDesktopNewFragmentString,
} from "./TeeSheetAgendaHeaderDesktopNew";
import {
  TeeSheetAgendaHeaderMobileNew,
  TeeSheetAgendaHeaderMobileNewFragmentString,
} from "./TeeSheetAgendaHeaderMobileNew";
import { TeeSheetAgendaHeaderDesktopNewFragment_club$key } from "./__generated__/TeeSheetAgendaHeaderDesktopNewFragment_club.graphql";
import { TeeSheetAgendaHeaderMobileNewFragment_club$key } from "./__generated__/TeeSheetAgendaHeaderMobileNewFragment_club.graphql";

type TeeSheetAgendaHeaderNewProps = {
  isMobileScreen: boolean;
  onBackPress?: () => void;
  isScrolled: boolean;
  title: string;
  clubDesktopRef: TeeSheetAgendaHeaderDesktopNewFragment_club$key;
  clubMobileRef: TeeSheetAgendaHeaderMobileNewFragment_club$key;
  onFilterPress?: () => void;
  onWaitlistPress?: () => void;
  courseFilterLabel?: string | null;
  variant?: "GOLF_COURSE" | "MULTI_SLOT" | "DINING";
  scrollY?: SharedValue<number>;
  showWaitlist?: boolean;
  startDate?: string;
  endDate?: string;
  selectedDate?: string;
  onDateChange?: (date: string) => void;
  clubWeekStartsOn?: NumericalDayOfWeek;
};

export const TeeSheetAgendaHeaderNew = ({
  isMobileScreen,
  onBackPress,
  isScrolled,
  title,
  onFilterPress,
  onWaitlistPress,
  courseFilterLabel,
  variant,
  clubDesktopRef,
  clubMobileRef,
  scrollY,
  showWaitlist,
  startDate,
  endDate,
  selectedDate,
  onDateChange,
  clubWeekStartsOn,
}: TeeSheetAgendaHeaderNewProps) => {
  if (isMobileScreen) {
    return (
      <TeeSheetAgendaHeaderMobileNew
        onBackPress={onBackPress}
        isScrolled={isScrolled}
        onFilterPress={onFilterPress ?? (() => {})}
        onWaitlistPress={onWaitlistPress}
        title={title}
        courseFilterLabel={courseFilterLabel}
        clubRef={clubMobileRef}
        scrollY={scrollY}
        startDate={startDate}
        endDate={endDate}
        selectedDate={selectedDate}
        onDateChange={onDateChange}
        clubWeekStartsOn={clubWeekStartsOn}
        showWaitlist={showWaitlist}
        variant={variant}
      />
    );
  }

  return (
    <TeeSheetAgendaHeaderDesktopNew
      onBackPress={onBackPress}
      isScrolled={isScrolled}
      title={title}
      clubRef={clubDesktopRef}
    />
  );
};

export {
  TeeSheetAgendaHeaderDesktopNewFragmentString,
  TeeSheetAgendaHeaderMobileNewFragmentString,
};
